"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
/* eslint-disable max-len */

const AALogo = () => {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "32",
    height: "33",
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M16 32.1528C24.8366 32.1528 32 24.9894 32 16.1528C32 7.31628 24.8366 0.152832 16 0.152832C7.16344 0.152832 0 7.31628 0 16.1528C0 24.9894 7.16344 32.1528 16 32.1528Z",
    fill: "#E94335"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16 32.1528C24.8366 32.1528 32 24.9894 32 16.1528C32 7.31628 24.8366 0.152832 16 0.152832C7.16344 0.152832 0 7.31628 0 16.1528C0 24.9894 7.16344 32.1528 16 32.1528Z",
    fill: "#E94335"
  }), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask0_2259_183841",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "32",
    height: "33"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M16 0.152832C24.8389 0.152832 32 7.31391 32 16.1528C32 24.9918 24.8389 32.1528 16 32.1528C7.16108 32.1528 0 24.9918 0 16.1528C0 7.31391 7.16108 0.152832 16 0.152832Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask0_2259_183841)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.3859 19.4739C13.6821 19.4739 12.3675 18.142 12.3675 16.4382C12.3675 14.769 13.6734 13.4112 15.3859 13.4112C17.0291 13.4112 18.3696 14.769 18.3696 16.4382C18.3696 18.142 17.0291 19.4739 15.3859 19.4739ZM19.9869 9.00038H19.4853L19.1999 10.3323C18.4129 8.75821 16.0691 8.60254 14.8064 8.60254C10.8713 8.60254 7.43774 12.3906 7.43774 17.5971C7.43774 21.7831 9.9372 24.4123 13.0767 24.4123C14.8323 24.4123 16.3199 24.0058 17.548 22.5442L17.228 24.0144H17.9459H22.175L24.4323 9.00903H19.9869V9.00038Z",
    fill: "white"
  })));
};
var _default = exports.default = AALogo;